import { retrieve, EndpointCall } from "components/http/endpoint";
import { ApiUriPrefix } from "../../../../apiUriPrefix";

const ApiUri = ApiUriPrefix + "evidence/clenove/detail-clena";

function apiLoadMemberData(memberIdt: number): EndpointCall {
    const uri = `${ApiUri}/osobni-udaje/${memberIdt}`;
    return retrieve(uri);
}



function apiGetMemberCardUrl(memberIdt: number) {
    return memberIdt ? `${ApiUriPrefix}/members/member-card/${memberIdt}` : "";
}

export {
    apiLoadMemberData,
    apiGetMemberCardUrl
}
